export enum DispatchStatusEnum {
    draft = 0, // No longer used
    instructed = 1,
    dispatched = 2,
}